import { httpManager as http } from '@/common/js/HttpManager';
import { config } from 'CONFIG';
import { downLoad } from '@/common/js/utils';
import { getCountryList } from '@/api/s3Config';
import moment from 'moment';

const timeStamp = process.env.TIME_STAMP;

export const getVideoList = ({

    device,
    startTime,
    endTime,
    page,
    showExpired,
    owner

}) => {

    if ( showExpired ) {

        startTime = moment().unix() * 1000;
        endTime = moment().add( 3, 'd' ).unix() * 1000;

    }
    return new Promise(( resolve, reject ) => {

        http.get( `/videos/?start_at=${startTime}&page=${page}${device ? `&uid=${device}` : ``}&end_at=${endTime}&count=${config.cloudVideoPageUnit}${showExpired ? `&date_type=expired_at` : ''}${owner ? `&owner=${owner}` : ''}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getOrtherList = ( opts ) => {

    let cTime = new Date().getTime();

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/?start_at=0&end_at=${cTime}&start_index=${opts.videoId}&count=${opts.count ? opts.count : 10}&order_way=${opts.order_way ? opts.order_way : 'desc'}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getVideoTotalNum = () => {

    let endTime = Date.now() + 24 * 60 * 60 * 1000;
    return new Promise(( resolve, reject ) => {

        http.get( `/videos/?start_at=0&end_at=${endTime}&count=1` ).then( res => {

            resolve( res.data.total );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getVideoInfoById = ( videoId ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/${videoId}/` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getVideoTimeMap = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/users/${id}/videos/timeMaps/` ).then( res => {

            resolve( res.data.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const videoplayerUrl = ( videoId, type ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/${videoId}/url?type=${type}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const downloadVideo = ( videoId ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/${videoId}/url?type=downLoad` ).then( res => {

            downLoad( res.data.url, `${videoId}.mp4` );

        }).catch( err => {

            reject( err );

        });

    });

};

export const deleteVideo = ( videoId ) => {

    let str = '';
    if ( typeof videoId === 'number' ) {

        str = `${videoId}`;

    } else if ( videoId instanceof Array ) {

        str = videoId.join( ',' );

    }
    return new Promise(( resolve, reject ) => {

        http.delete( `/videos/${str}` ).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

};
let str = moment().format( 'YYYY-MM-DD' );
export const start = moment( `${str} 00:00:00`, 'YYYY-MM-DD HH:mm:ss' ).subtract( 1, 'y' ).unix() * 1000;
export const end = moment( `${str} 00:00:00`, 'YYYY-MM-DD HH:mm:ss' ).add( 1, 'd' ).unix() * 1000;

export const getTimeMap = ( uid, owner ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/quantity?start_at=${start}&end_at=${end}${uid ? `&uid=${uid}` : ``}${owner ? `&owner=${owner}` : ``}` ).then( res => {

            let data = res.data.videos;
            let timeMaps = data.map(( time ) => {

                return moment( start ).add( time.index, 'd' ).format( 'YYYY-MM-DD' );

            });
            resolve( timeMaps );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceList = () => {

    return new Promise(( resolve, reject ) => {

        http.get( `/devices/?owner=@me` ).then( res => {

            resolve( res.data.devices );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceIdsHasVideo = () => {

    return new Promise(( resolve, reject ) => {

        http.get( '/videos/devices' ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceInfoHasVideo = () => {

    return new Promise(( resolve, reject ) => {

        Promise.all( [

            getDeviceIdsHasVideo(),
            getDeviceList()

        ] ).then( res => {

            let [ ids, devices ] = res;
            let result = [];
            ids = ids.map(( item ) => item.uid );
            if ( ids.length && devices.length ) {

                result = devices.filter(({uid}) => ids.includes( uid ));

            }
            resolve( result );

        }).catch( err => {

            reject( err );

        });

    });

};

export const updateVideoTitle = ( videoId, title ) => {

    return new Promise(( resolve, reject ) => {

        http.patch( `/videos/${videoId}`, { 'title': title }).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

};

export const verify = ( email ) => {

    return new Promise(( resolve, reject ) => {

        http.post( '/users/identification/', {

            type: 'email',
            clientId: config.clientId,
            action: 'account_service.verify_email_address',
            email: {

                ttl: 60,
                args: {

                    address: email,
                    redirect: window.location.href

                }

            }

        }).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export function getSupportedCountriesCodes () {

    return new Promise(( resolve, reject ) => {

        http.get( `/storage/availabilities/?client_id=${config.clientId}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

}

export const getSupportedCountries = async () => {

    let [ countryList, supportedCountriesCodes ] = await Promise.all( [
        getCountryList(),
        getSupportedCountriesCodes()
    ] );
    return countryList.filter(
        country => supportedCountriesCodes.includes( country.code )
    ).map(
        country => {

            return {

                code: country.code,
                text: country.name,
                image: `https://cdn.reolink.com/wp-content/assets/carrier/${country.name.toLowerCase().split( ' ' ).join( '_' )}.png?sv=${timeStamp}`

            };

        }

    );

};



// WEBPACK FOOTER //
// ./src/api/cloud.js